var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHoverRightArrow = function SvgHoverRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    transform: "matrix(-1 0 0 1 43 0)",
    fill: "#fff",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    transform: "matrix(-1 0 0 1 43 0)",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.518 19.87-4.266-4.266a.93.93 0 1 0-1.31 1.32l4.275 4.256a.928.928 0 0 1 0 1.32l-4.276 4.256a.93.93 0 1 0 1.31 1.32l4.267-4.266a2.788 2.788 0 0 0 0-3.94Z",
    fill: "#fff"
  })));
};
export default SvgHoverRightArrow;